import React, { Component } from 'react';
import { connect } from 'react-redux';
import SectionheaderWrapper from './styles/sectionheader.style';
import { Menu, Dropdown, Input, Form, Button, Popover, notification} from 'antd';
import { Scrollbars } from 'react-custom-scrollbars-2';
import UserDetails from '../../userDetails/userDetails';
import PermissionBox from '../../permissionBox/permissionBox';
import Loader from '../../../components/Loader/loader';
import * as DeviceDetails from '../../../utils/deviceDetails';
import { VideoProvider } from '../../../components/VideoProvider';
import { baseChatURL } from '../../../constants/global';
import * as UserApis from '../../../apis/user'
import {getInitials} from '../../../utils/fetchImageUtils'
import * as UserActions from '../../../actions/contacts';

const connectionOptions  = {
	bandwidthProfile: {
	  video: {
		mode: 'collaboration',
		renderDimensions: {
		  high: { height: 1080, width: 1920 },
		  standard: { height: 90, width: 160 },
		  low: { height: 90, width: 160 },
		},
	  },
	},
	dominantSpeaker: true,
	maxAudioBitrate: 12000,
	networkQuality: { local: 1, remote: 1 },
	preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
  };

const validateMessages = {
	required: '${label} is required!',
};

function WarningMessage(props){
	return(
		<div className="WarningMessage">
			<h1>kure works best on the latest version of Chrome or Safari. Don’t have them installed? Download <a href="https://www.google.com/chrome/?brand=CHBD&gclid=EAIaIQobChMIuvq127ry6wIVR6aWCh3I1g1CEAAYASAAEgIxM_D_BwE&gclsrc=aw.ds" target="_blank">Chrome</a> or <a href="https://support.apple.com/downloads/safari" target="_blank">Safari</a>.</h1>
			<button onClick={props.closeWarning}  className="closewarningmsg">&times;</button>
		</div>
	)
}

// const headerText = (
// 	<header>
// 		<h1>Logged in as</h1>
// 		<div className="name">minnie mouse</div>
// 		<div className="phone">+1 704 123 4567</div>
// 	</header>
// 	);
// const content = (
// 	<div className="dropdowMenu">
// 		<h1>YOUR VIDEO ROOM STATUS</h1>
// 		<Form  name="nest-messages" validateMessages={validateMessages}>
// 			<ul>
// 				<li>
// 					<div className="list-content">
// 						<h1>Available</h1>
// 						<Form.Item>
// 							<Button className="button available" type="primary" htmlType="submit">
// 							set
// 							</Button>
// 						</Form.Item>
// 						{/* <button className="button available">set</button> */}
// 					</div>
// 				</li>
// 				<li>
// 					<div className="list-content">
// 						<h1>On another call</h1>
// 						<Form.Item>
// 							<Button className="button on-other-call" type="primary" htmlType="submit">
// 							set
// 							</Button>
// 						</Form.Item>
// 					</div>
// 					<div className="note">
// 						This status is added by default when you are on a call
// 					</div>
// 				</li>
// 				<li>
// 					<div className="list-content">
// 						<h1>Busy</h1>
// 						<Form.Item>
// 							<Button className="button busy" type="primary" htmlType="submit">
// 							set
// 							</Button>
// 						</Form.Item>
// 					</div>
// 					<div className="message-text">
// 						<Form.Item name={['user', 'busy-message']} label="" rules={[{ required: true }]}>
// 							<Input.TextArea placeholder="Add an optional message to your busy status" />
// 						</Form.Item>
// 					</div>
// 				</li>
// 			</ul>
// 			<footer>
// 				<Form.Item>
// 					<Button className="logoutbtn" type="primary" htmlType="submit">Logout</Button>
// 				</Form.Item>
// 			</footer>
// 		</Form>
// 	</div>
//   );

class SectionHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isDropdown:false,
			warningVisible:true,
			OpenMask:false,
			showLocalVideo: false,
			joinVideoRoomDropdown:false,
			userList: [],
			recentUserList: [],
			searchText: '',
			showLoader: false,
			showInviteModal: false,
		}
		this.handleClick=this.handleClick.bind(this);
		this.handleOutsideClick=this.handleOutsideClick.bind(this);
		this.closeWarning=this.closeWarning.bind(this);
		this.box = React.createRef();
	}

	verifyUser = () => {
		this.setState({
			showLocalVideo: true
		});
	}

	componentDidMount(){
		const { dispatch, match } = this.props;
		//document.addEventListener('click', this.handleOutsideClick);

		const deviceBrowser = DeviceDetails.getBrowser();
		if(deviceBrowser && ["chrome", "safari"].indexOf(deviceBrowser.toLowerCase()) !== -1){
			this.setState({
				warningVisible: false
			})
		}
		dispatch(UserActions.getUserContactList())
	}

	handleClick() {
		if (!this.state.isDropdown) {
		  document.addEventListener('click', this.handleOutsideClick, false);
		} else {
		  document.removeEventListener('click', this.handleOutsideClick, false);
		}
		this.setState(prevState => ({
		  isDropdown: !prevState.isDropdown,
		}));
	  }

	  closeWarning = () => {
			this.setState({
				warningVisible: false,
		  });  
	  }
	handleOutsideClick(e) {
		// if (this.box && !this.box.current.contains(e.target)) {
		// 	alert('you just clicked outside of box!');
		//   }
			if (this.box && this.box.current && this.box.current.contains(e.target)) {
				return;
			}
			this.handleClick(); 
		
		
		// if (this.node.contains(e.target)) {
		//   return;
		// }
		// this.handleClick();
	}

	  onFieldUpdate = async (val) => {

		if (val.length > 2) {
			
			  let reqObject = {
				  "search": val
			  }
			  
			  const response = await UserApis.getUserList(reqObject);
			  if (response.data)
				  this.setState({ userList: response.data, searchText:val })
		  } else {
			this.setState({ searchText:val})
		  }

	  }

	  onRoomLinkUpdate = async (val) => {
			this.setState({ roomLink:val})
	  }

	  openInviteModal = () => {
		const {showInviteModal} = this.state
		this.setState(prevState => ({
			showInviteModal: !prevState.showInviteModal,
			joinVideoRoomDropdown: false
		}))
	  }
	  

	fetchUsers = async () => {
		const {userList, recentUserList, joinVideoRoomDropdown, searchText} = this.state
		this.setState(prevState => ({
			joinVideoRoomDropdown: !prevState.joinVideoRoomDropdown,
			showInviteModal:false
		}))

		if(joinVideoRoomDropdown == true) return
		this.setState(prevState => ({
			showLoader:true
		}))

		if (!userList || userList.length == 0) {
			let reqObject = {
				"search": searchText
			}

			const response = await UserApis.getUserList(reqObject);
			if(response.data)
				this.setState({userList: response.data})
		}

		if (!recentUserList || recentUserList.length == 0) {
			const response = await UserApis.getRecentUserList();
			if(response.data){
				// let reversedResponseData = response.data.reverse()
				let newUserList = []
				for(let i in response.data){
					if(i < 15){
						newUserList.push(response.data[i])
					} else {
						break
					}
				}
				this.setState({recentUserList: newUserList})
			}
		}

		this.setState({showLoader: false})

	}

	joinRoom = (user) => {
		window.location.assign(`/videoRoom/${user.roomID}`);
	}

	joinRoomFromLink = () => {
		let { roomLink } = this.state
		if(!roomLink || roomLink == ''){
			notification['error']({
                message: 'Error',
                description: 'Please enter the Video Room link',
            });
			return
		}

		let count = 0
		if(roomLink.includes('/')){
			let splittedArray = roomLink.split('/');
			roomLink = splittedArray[splittedArray.length-1]
		}
		window.location.assign(`/videoRoom/${roomLink}`);
	}

	hideModal = () => {
		this.setState({joinVideoRoomDropdown: false, isDropdown: false, showInviteModal: false})
	}


	render() {
		const { setting, therapistRoom, contact } = this.props;
		const { userList, recentUserList, searchText, showLoader} = this.state
		let { currentUser, currentUserStatus } = setting;
		const { openEmailLink, copyToClipBoard, openInviteModal } = this.props;
		
		let contactsList = contact.contacts? contact.contacts : []
		if(!searchText || searchText == '' || searchText.length < 3){
			if(searchText.length){
				contactsList = contact.contacts.filter(contact => (contact.firstName + " " + contact.lastName).toLowerCase().includes(searchText.toLowerCase()))
			}
		}

		if(searchText && searchText.length >= 3){
			contactsList = contact.contacts.filter(contact => (contact.firstName + " " + contact.lastName).toLowerCase().includes(searchText.toLowerCase()))
			if(userList){
				for(let i of userList){
					if(!contactsList.some(contact => contact.mobileNumber == i.mobileNumber)){
						let hideNumber = (currentUser && currentUser.isPatient && currentUser.isPatient == true)? true : false

						let contactItem = {
							...i,
							hideNumber: hideNumber
						}
						contactsList.push(contactItem)
					}
					
				}
			}
		}


		let userStatusClass= "available";
		if(!currentUserStatus){
			currentUserStatus = "available";
		}

		if(currentUserStatus.toLowerCase() === "on another call"){
			userStatusClass="on-other-call";
		}else if(currentUserStatus.toLowerCase() === "busy"){
			userStatusClass = "busy"
		}

		let camName = "";
		if(currentUser && currentUser.firstName){
			camName = currentUser.firstName + " " + currentUser.lastName;
		}
		
		// const menu = (
		// 	<Menu className="invite-dropdown">
		// 	  <Menu.Item key="0" onClick={openInviteModal}>
		// 		Text Message
		// 	  </Menu.Item>
		// 	  <Menu.Divider />
		// 	  <Menu.Item key="1" onClick={openEmailLink}>
		// 		Email
		// 	  </Menu.Item>
		// 	</Menu>
		// );

		const inviteMenu = (
			<Menu className="invite-dropdown" style={{ width: 340 }}>
				<Menu.Item key="0">
					<div className="phonefield copy-field">
						<input className="copylink-textbox" readOnly id="phone" name="phone" value={(baseChatURL + "/videoroom/" + therapistRoom)} type="text" />
						<span type="button" className="copylink" onClick={copyToClipBoard} ></span>
					</div>
					<button type="button" className="button-el fill copylink" onClick={copyToClipBoard} >COPY LINK</button>
				</Menu.Item>
				<Menu.Divider />
				<Menu.Item key="1" onClick={openInviteModal}>
					<button type="button" className="button-el copylink" >Invite via Text Message</button>
				</Menu.Item>
				<Menu.Item key="2" onClick={openEmailLink}>
					<button type="button" className="button-el copylink" >Invite via Email</button>
				</Menu.Item>
			</Menu>
		);
		const joinRoomMenu = (

			<Menu className="invite-dropdown" style={{ width: 380 }}>
				<Menu.Item key="3">
					<div className="phonefield video-room-field">
						<input className="video-room-textbox" id="phone" name="phone" type="text" placeholder="Video Room Link" onChange={(e) => this.onRoomLinkUpdate(e.target.value)} />
					</div>
					<button type="button" className="button-el fill navy copylink text-uppercase"  onClick={()=> this.joinRoomFromLink()}>join video room</button>
				</Menu.Item>
				<Menu.Divider />
				<Menu.Item key="4">
					<div className="join_room_content">
						{showLoader == true ?
						<div className="_loader"><Loader /></div>
						:
						<>
						<div className="search_people">
							<input type="search" placeholder="Search People" onChange={e => this.onFieldUpdate(e.target.value)} />
						</div>
						<div className="recent_joinees">
							<Scrollbars style={{ height:75 }}>
							<ul>
								{recentUserList && recentUserList.map( user => 
									<li>
										<div className="_profile" onClick={()=> this.joinRoom(user)}>
											{user.profilePictureUrl && user.profilePictureUrl.includes('http') ?
											<div className="_profile_picture"><img src={user.profilePictureUrl} /></div> :
											<abbr>{getInitials(user.firstName + " " + user.firstName)}</abbr>
											}
											
											<div className="_name" title="Victoria Flanagan-Grimsrud">{user.firstName} {user.lastName} </div>
										</div>
									</li>
								)}
								{/* <li>
									<div className="_profile">
										<abbr>vf</abbr>
										<div className="_name" title="Victoria Flanagan-Grimsrud">Victoria Flanagan-Grimsrud</div>
									</div>
								</li>
								<li>
									<div className="_profile">
										<img src="https://preview.compleatkidz.com/uploads/teams/user-1665764334.png" />
										<div className="_name" title="Nikita Bagrodia">Nikita Bagrodia</div>
									</div>
								</li> */}
							</ul>
							</Scrollbars>
						</div>
						
						<div className="search_list">
							<Scrollbars>
								<div className="scrollable-content">
									<ul>
										{contactsList && contactsList.map(user =>
											<li key={user.id}>
												<div className="_profile_wrapper">
													{ user.profilePictureUrl && user.profilePictureUrl.includes('http') ?
														<span><img src={user.profilePictureUrl} /></span>
														:
														<abbr>{getInitials(user.firstName + " " + user.lastName)}</abbr>
													}
													 
													<div className="_profile">
														<h2>{user.firstName} {user.lastName}</h2>
														<h3>{user.discipline}</h3>
													{/* {(!user.hideNumber) && <h3>{user.mobileNumber}</h3>} */}
													</div>
												</div>
												<button className="join_btn" onClick={()=> this.joinRoom(user)}>join</button>
											</li>
										)}
									</ul>
								</div>
							</Scrollbars>
						</div>
						</>				
						}
					</div>
				</Menu.Item>
			</Menu>
			
		);

		
		return (
			<SectionheaderWrapper>
			{this.state.warningVisible &&
			<WarningMessage closeWarning={this.closeWarning} />
			}
			
			<header>
				<div className="top-bar"> 
					<h1>To invite someone to your waiting room, share this link:</h1>
					<div ref={node => { this.node = node; }} className="user-profile-info">
					{this.state.OpenMask && <div className="userprofile_mask"></div> }
                      <div className="user__profile">
                          <div className="thumb-inner"	>
						  {/* <h1>{currentUser.firstName + " " + currentUser.lastName}</h1> */}
							<div className={`user-status ${userStatusClass}`}>{currentUserStatus}</div>
							
							<Popover  overlayClassName="userDropdown" placement="bottomRight" content={<UserDetails currentUser={currentUser} therapistRoom={therapistRoom} />} trigger="click">
								
								<img onClick={this.showMask} src={currentUser.profilePictureUrl !== "" && currentUser.profilePictureUrl.includes('http') ? currentUser.profilePictureUrl : 
										"https://static.sendbird.com/sample/profiles/profile_35_512px.png"}/>


								</Popover>
							</div>
                    	 </div>
                     </div>
				</div>
				<div className="linkRow">
						<div className="linkRow-container gap-1">
						{/* <div className="textBoxCont">
							<div className="phonefield">
								<input className="copylink-textbox" readOnly id="phone" name="phone" value={(baseChatURL+"/videoroom/"+therapistRoom)} type="text" />
								<button type="button" className="copylink" onClick={copyToClipBoard} >copy link</button>
							</div>
						</div> */}
						<div className="invite-source">
								<Dropdown onClick={() => {
									this.openInviteModal()
								}} visible={this.state.showInviteModal}
									overlayClassName="dropdown-invite"
									overlay={inviteMenu} trigger={['click']}>
									<button className="invite-via">Invite to your video room</button>
								</Dropdown>
						</div>
						<div className="join-video-room"   >
								<Dropdown overlayClassName="dropdown-invite" onClick={() => {
									this.fetchUsers()
								}} visible={this.state.joinVideoRoomDropdown} overlay={joinRoomMenu} trigger={['click']}>
									<button className="invite-via">JOIN A VIDEO ROOM</button>
								</Dropdown>
						</div>
					</div>
				</div>
				</header>
				{(this.state.joinVideoRoomDropdown == true || this.state.showInviteModal == true) && <div className="_overlay" onClick={() => this.hideModal()}></div>	}			
				<VideoProvider options={connectionOptions}>
					<PermissionBox camName={camName} showLocalVideo={this.state.showLocalVideo} verifyUser={this.verifyUser}/>
				</VideoProvider>
			</SectionheaderWrapper>
		  ) 
	}
}

export default connect(
	state => state
)(SectionHeader);
